/* Logger Web Vitals (INP/CLS) z attribution -> dataLayer (event: web_vitals).
   Biblioteka doładowywana dopiero po onload + idle, żeby nie dotykać LCP/TBT. */
(function () {
  var me = document.currentScript;
  if (!me) return;
  var libSrc = me.getAttribute('data-lib');
  var template = me.getAttribute('data-template') || '';
  if (!libSrc) return;

  function worstScript(attr) {
    var frames = attr.longAnimationFrameEntries || [];
    var worst = null;
    for (var i = 0; i < frames.length; i++) {
      var scripts = frames[i].scripts || [];
      for (var j = 0; j < scripts.length; j++) {
        if (!worst || scripts[j].duration > worst.duration) worst = scripts[j];
      }
    }
    if (!worst) return '';
    return String(worst.sourceURL || worst.invoker || '').slice(0, 120);
  }

  /* Nie wysylaj, gdy sesja GA4 wygasla (>29 min od ostatniego hitu) - event
     wyslany do martwej sesji mintuje nowa sesje-ducha (session_start +
     web_vitals bez page_view). Ostatnia aktywnosc czytamy z ciastka _ga_*
     (GS1: pole z epochem; GS2: segment t<epoch>). Brak ciastka = wysylamy. */
  function sessionAlive() {
    var m = document.cookie.match(/_ga_[A-Z0-9]+=([^;]+)/);
    if (!m) return true;
    var ts = m[1].match(/\d{10}/g);
    if (!ts || !ts.length) return true;
    var last = Math.max.apply(null, ts.map(Number));
    return (Date.now() / 1000 - last) < 1740;
  }

  function send(metric) {
    if (!sessionAlive()) return;
    var a = metric.attribution || {};
    var payload = {
      event: 'web_vitals',
      wv_name: metric.name,
      wv_value: Math.round(metric.value * (metric.name === 'CLS' ? 1000 : 1)),
      wv_rating: metric.rating,
      wv_template: template,
    };
    if (metric.name === 'INP') {
      payload.wv_target = String(a.interactionTarget || '').slice(0, 120);
      payload.wv_type = a.interactionType || '';
      payload.wv_input_delay = Math.round(a.inputDelay || 0);
      payload.wv_processing = Math.round(a.processingDuration || 0);
      payload.wv_presentation = Math.round(a.presentationDelay || 0);
      payload.wv_script = worstScript(a);
    }
    if (metric.name === 'CLS') {
      payload.wv_target = String(a.largestShiftTarget || '').slice(0, 120);
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function boot() {
    var s = document.createElement('script');
    s.src = libSrc;
    s.onload = function () {
      var wv = window.webVitals;
      if (!wv || !wv.onINP) return;
      wv.onINP(send);
      wv.onCLS(send);
    };
    document.head.appendChild(s);
  }

  function idle() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(boot, { timeout: 4000 });
    } else {
      setTimeout(boot, 2000);
    }
  }

  if (document.readyState === 'complete') {
    idle();
  } else {
    window.addEventListener('load', idle, { once: true });
  }
})();
